<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page-options="[10, 25, 50, 100]"
    :search="search"
    v-bind="pagingOptions"
    :hide-default-footer="hideFooter"
    v-model="selected"
    show-select
    @input="onSelectItem"
  >
    <template v-slot:item.supplierName="{ item }">
      <supplier-label
        v-if="item.supplier"
        v-model="item.supplierName"
        :supplier-type="item.supplier.serviceType"
        :supplier-id="item.supplier.id"
      ></supplier-label>
    </template>
    <template v-slot:item.itineraryStartDate="{ item }">{{
      item.itineraryStartDate | formatDate
    }}</template>
    <template v-slot:item.firstServiceStartDate="{ item }">{{
      item.firstServiceStartDate | formatDate
    }}</template>
    <template v-slot:item.createdAt="{ item }">{{
      item.createdAt | formatDate
    }}</template>
    <template v-slot:item.approvedAt="{ item }">{{
      item.approvedAt | formatDate
    }}</template>
    <template v-slot:item.exportedAt="{ item }">{{
      item.exportedAt | formatDate
    }}</template>
    <template v-slot:item.supplierInvoiceDate="{ item }">{{
      item.supplierInvoiceDate | formatDate
    }}</template>
    <template v-slot:item.itineraryReference="{ item }">
      <reference-label
        v-model="item.itineraryReference"
        :itinerary-id="item.itinerary ? item.itinerary.id : ''"
      ></reference-label>
    </template>
    <template v-slot:item.supplierEmail="{ item }">
      {{ item.supplier ? item.supplier.email : "" }}</template
    >
    <template v-slot:item.accountsEmail="{ item }">
      {{ item.supplier ? item.supplier.accountsEmail : "" }}
    </template>
    <template v-slot:item.paymentMethod="{ item }">
      {{ item.supplier ? item.supplier.paymentMethod : "" }}
    </template>
    <template v-slot:item.destinationName="{ item }">
      {{ item.supplier ? item.supplier.destinationName : "" }}
    </template>
    <template v-slot:item.payeeName="{ item }">
      {{ item.supplier ? item.supplier.payeeName : "" }}
    </template>
    <template v-slot:item.amount="{ item }">{{
      item.amount | priceLabeler
    }}</template>
    <template v-slot:item.actions="{ item }">
      <default-list-actions
        :item="item"
        :hide-view="true"
        :hide-remove="
          $store.getters.hasAccessTo('finances:pi_view_only') ||
          !$store.getters.hasAccessTo('finances:delete')
        "
        @deleteItem="deleteItem($event)"
        @editItem="editItem($event)"
      ></default-list-actions>
    </template>
    <template v-slot:footer>
      <v-layout justify-space-around>
        <list-totals v-model="totalsColumns" :items="items"></list-totals>
      </v-layout>
      <v-row v-if="debug">
        <v-col>
          <pre>{{ selected }}</pre>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import ReferenceLabel from "../../shared/labels/ReferenceLabel";
import SupplierLabel from "../../shared/labels/SupplierLabel";
import { pagingOptions } from "../../../../helpers/index";
import ListTotals from "../../shared/ListTotals.vue";
import { Ref } from "vue-property-decorator";
export default {
  name: "pi-table",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },

  components: { DefaultListActions, ListTotals, ReferenceLabel, SupplierLabel },

  data() {
    return {
      debug: false,
      pagingOptions,
      selected: this.selectedItems.filter((value) =>
        this.items.includes(value)
      ),
    };
  },

  computed: {
    totalsColumns() {
      const cols = ["amount", "paid", "vatAmount", "netAmount", "balance"];
      return this.headers.filter((h) => cols.indexOf(h.name) != -1);
    },
    totalPrice() {
      let total = 0;
      if (this.items.length > 0) {
        total = this.items.reduce(
          (t, item) => Number(t) + Number(item.amount),
          total
        );
      }
      return total.toFixed(2);
    },
  },

  watch: {},

  methods: {
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    },
    onSelectItem(payload) {
      this.$emit("updateSelection", {
        items: [...this.items],
        selected: [...this.selected],
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoices/PiTable.vue